import { IRootState } from "../../rootReducer";
import { IAudioVoice } from "./IAudioVoice";
import { IAudioPositionMarkers } from "./IAudioPositionMarkers";
import { IOption } from "../../../app/components/Select";

export function getVoices(state: IRootState): Array<IAudioVoice> {
  return state.audio.voices;
}

export function getOptions(state: IRootState): Array<IOption> {
  return state.audio.voices.map(({ abbr, name }) => ({ value: name, label: abbr, }));
}

export function getIsPlaying(state: IRootState): boolean {
  return state.audio.isPlaying;
}

export function getIsPaused(state: IRootState): boolean {
  return state.audio.isPaused;
}

export function getRate(state: IRootState): number {
  return state.audio.rate;
}

export function getSelectedVoice(state: IRootState): string {
  return state.audio.selectedVoice;
}

export const hasSelectedVoice = (state: IRootState) => Boolean(getSelectedVoice(state));

export function getStartingPosition(state: IRootState): IAudioPositionMarkers {
  return state.audio.highlightPosition;
}
